<template>
  <div class="footer">
    <div class="reCaptchaInfo">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div>
    <nav>
      <ul>
        <li><a target="_blank" href="https://pitacoin.themedia.jp/posts/3239377">プライバシーポリシー</a></li>
        <li><a target="_blank" href="https://pitacoin.themedia.jp/posts/3239382">利用規約</a></li>
        <li><a target="_blank" href="https://pitacoin.themedia.jp/pages/1424189/page_201603171850">お問い合わせ</a></li>
      </ul>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  components: {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer{
    background: #fff;
    padding-top: 30px;
    padding-bottom: 50px;
  }
  ul{
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
  }
  li{
    list-style: none;
    margin: 0 10px;
    font-size: 14px;
  }
  a{
    text-decoration: none;
    color: #333;
  }
  a:hover{
    text-decoration: underline;
  }
  .reCaptchaInfo{
    padding-top: 10px;
    font-size: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  @media all and (max-width: 480px) {
    ul{
      display: block;
      text-align: center;
    }
    li{
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue